import { render, staticRenderFns } from "./DeliveriesPerWeekTable.vue?vue&type=template&id=4f91e58e&"
import script from "./DeliveriesPerWeekTable.vue?vue&type=script&lang=js&"
export * from "./DeliveriesPerWeekTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports